<template>
  <li v-if="labels">
    <slot />
    <input
        type="radio"
        :name="name"
        :id="title"
        :disabled="disabled"
        :required="required"
        :value="value"
        :checked="checked"
        @change="$emit('change', value)"
    />
    <label :for="title" :class="{ 'invalid': error }">{{ title }}</label>
  </li>
  <p v-else class="field field_radio">
    <slot />
    <input
        type="radio"
        :name="name"
        :id="name"
        :disabled="disabled"
        :required="required"
        :value="value"
        :checked="checked"
        @change="$emit('change', value)"
    />
    <label :for="name">{{ title }}</label>
  </p>
</template>

<script>
export default {
  name: 'app-radio-button',
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    value: {
      type: [String, Number, Object],
      default: 'RadioButton'
    },
    modelValue: {
      type: [String, Number, Object],
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    labels: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    checked() {
      return this.modelValue === this.value
    }
  }
}
</script>
